// Pod visualization colors (mic ring / glow / off state) — previously
// copy-pasted as local constants in expert-rating, student-dashboard,
// byod-join and profile-creation.
export const POD_ON_COLOR = "#FF6655"
export const POD_OFF_COLOR = "#D0D0D0"
export const GLOW_COLOR = "#ffc3bd"
